module.exports = __webpack_public_path__ + "img/lt_designated_interpreter.e7a2eb25.png";